import React from "react"
import { css } from "@emotion/core"

import * as mixins from "../../utils/mixins"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { servicesPageMetadata } from "../../utils/seo"

import TopDisplayImageCont from "../components/imageComponents/TopDisplayImageCont"
import { TopImage } from "../components/imageComponents/optimized/services"
import { OurServicesTopImageTitle } from "../components/layoutComponents/top-image-title"

import {
  ESCPlanningTitle,
  MethodsTitle,
  HydroseedingTitle,
  InspectionsTitle,
} from "../components/ourServices/titleBar"

import {
  ESCPlanningServiceContainer,
  MethodsServiceContainer,
  HydroseedingServiceContainer,
  InspectionsServiceContainer,
} from "../components/ourServices/serviceOptions"

import * as TextComponent from "../components/textComponents"
import * as LayoutComponent from "../components/layoutComponents"
import * as InteractiveComponent from "../components/interactiveComponents"

function ServicesPage() {
  return (
    <Layout>
      <SEO
        title="Our Services"
        description="Marin County's Landscaper. From Site Planning to Landscaping to Revegetation."
        meta={servicesPageMetadata}
      />
      <TopDisplayImageCont>
        <OurServicesTopImageTitle />
        <TopImage />
      </TopDisplayImageCont>

      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText
          styles={css`
            ${mixins.device.tablet} {
              margin-bottom: 0.5rem;
            }
          `}
        >
          As Marin County&apos;s landscaping specialists, we offer encompassing
          services to tackle any landscaping job, from backyards to baseball
          fields. Check out our services!
        </TextComponent.BodyText>
      </LayoutComponent.SectionContainer>

      <div
        css={css`
          ${mixins.device.tablet} {
            margin: 0 0.75rem;
          }

          ${mixins.device.laptop} {
            margin: 0 1rem;
          }
        `}
      >
        <ESCPlanningServiceContainer>
          <ESCPlanningTitle />
        </ESCPlanningServiceContainer>

        <MethodsServiceContainer>
          <MethodsTitle />
        </MethodsServiceContainer>

        <HydroseedingServiceContainer>
          <HydroseedingTitle />
        </HydroseedingServiceContainer>

        <InspectionsServiceContainer>
          <InspectionsTitle />
        </InspectionsServiceContainer>
      </div>

      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText
          styles={css`
            margin-top: 1rem;
          `}
        >
          <TextComponent.BodyBold>Have questions?</TextComponent.BodyBold> Get
          in touch, we’d love to find out how we can save you time and money on
          your project.
        </TextComponent.BodyText>

        <InteractiveComponent.Button to="/contact-us/">
          CONTACT US
        </InteractiveComponent.Button>
      </LayoutComponent.SectionContainer>
    </Layout>
  )
}

export default ServicesPage
